import script from "./SigCommitterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SigCommitterPage.vue?vue&type=script&setup=true&lang=js"

import "./SigCommitterPage.vue?vue&type=style&index=0&id=f7949d46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7949d46"]])

export default __exports__